import { useMemo } from "react";
import Confirmed from "../../../assets/order-activity/confirmed.svg";
import Delivered from "../../../assets/order-activity/delivered.svg";
import DispatchReady from "../../../assets/order-activity/dispatch_ready.svg";
import Dispatched from "../../../assets/order-activity/dispatched.svg";
import Packaged from "../../../assets/order-activity/packaged.svg";
import Verified from "../../../assets/order-activity/verified.svg";
import Cancelled from "../../../assets/order-activity/cancelled.svg";
const lookupIcon = (status) => {
    switch (status) {
        case "ordered":
            return Confirmed;
        case "delivered":
        case "fulfilled":
            return Delivered;
        case "dispatch-ready":
            return DispatchReady;
        case "dispatched":
            return Dispatched;
        case "packed":
        case "processing":
            return Packaged;
        case "verified":
            return Verified;
        case "cancelled":
            return Cancelled;
    }
};
const lookupLabel = (status) => {
    switch (status) {
        case "ordered":
            return "Your order has been confirmed.";
        case "delivered":
        case "fulfilled":
            return "Your order has been delivered. Thank you for shopping at SCEE!";
        case "dispatch-ready":
            return "Your order has reached the dispatch center.";
        case "dispatched":
        case "in-transit":
            return "Our delivery driver has picked-up your order for delivery.";
        case "packed":
            return "Your order has been packed.";
        case "processing":
            return "Your order is being processed.";
        case "verified":
            return "Your order is successfully verified.";
        case "cancelled":
            return "Your order has been cancelled.";
    }
};
export function useOrderActivityState({ history = [] }) {
    const activities = useMemo(() => history?.map((entry) => ({ ...entry, label: lookupLabel(entry.status.toLowerCase()), icon: lookupIcon(entry.status.toLowerCase()) })), [history]);
    return useMemo(() => ({
        activities,
    }), [activities]);
}
